import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * タグ
 *【内容:content:string】
 *【2ndデザイン:secondary:boolean】
 *【選択:selected:boolean】
 *【ボーダーデザイン:isDefault:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tag',
  templateUrl: './tag.html',
  styles: [`
    
  `]
})
export class Tag extends BaseWidget {
  /**
   * 選択の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * 選択
   */
  @Input() selected:boolean

  /**
   * ボーダーデザイン
   */
  @Input() isDefault:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * 選択状態を更新する
   * @param {Event} event
   *
   */
  updateChecked(event:Event): boolean {
    const value = !!this.selected ? false : true
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
    return this.selected ? !this.selected : this.selected
  }
  
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/checkbox/tag/tag.component.ts